import Login from "src/components/Dashboard/Views/Pages/Login.vue";
import LoginUser from "src/components/Dashboard/Views/Pages/LoginUser.vue";
import UserDashboardLayout from "../components/Dashboard/Layout/DashboardLayoutUser.vue";
import FulfillerDashboardLayout from "../components/Dashboard/Layout/FulfillerDashboardLayout.vue";

//fulfiller Layout
const fulfillerDashboard = () =>
  import(
    /* webpackChunkName: "FulfillerDashboard" */ "src/components/Dashboard/Views/Fulfiller/dashboard.vue"
  );
const fulfillerOrder = () =>
  import(
    /* webpackChunkName: "FulfillerOrder" */ "src/components/Dashboard/Views/Fulfiller/order.vue"
  );
const fulfillerOrderHistory = () =>
  import(
    /* webpackChunkName: "FulfillerOrderHistory" */ "src/components/Dashboard/Views/Fulfiller/orderHistory.vue"
  );
const fulfillerMenu = () =>
  import(
    /* webpackChunkName: "FulfillerMenu" */ "src/components/Dashboard/Views/Fulfiller/menu.vue"
  );
const fulfillerMenuAdd = () =>
  import(
    /* webpackChunkName: "AddFulfillerMenu" */ "src/components/Dashboard/Views/Fulfiller/menuAdd.vue"
  );
const fulfillerMenuEdit = () =>
  import(
    /* webpackChunkName: "EditFulfillerMenu" */ "src/components/Dashboard/Views/Fulfiller/menuEdit.vue"
  );
const fulfillerChangePassword = () =>
  import(
    /* webpackChunkName: "ChangeFulfillerPassword" */ "src/components/Dashboard/Views/Fulfiller/changePassword.vue"
  );

const fulfiller = () =>
  import(
    /* webpackChunkName: "Fulfiller" */ "src/components/Dashboard/Views/Fulfiller/fulfiller.vue"
  );
const fulfillerAdd = () =>
  import(
    /* webpackChunkName: "AddFulfiller" */ "src/components/Dashboard/Views/Fulfiller/fulfillerAdd.vue"
  );
const receiver = () =>
  import(
    /* webpackChunkName: "Receiver" */ "src/components/Dashboard/Views/Fulfiller/receiver.vue"
  );
const receiverAdd = () =>
  import(
    /* webpackChunkName: "AddReceiver" */ "src/components/Dashboard/Views/Fulfiller/receiverAdd.vue"
  );
const deliverer = () =>
  import(
    /* webpackChunkName: "Deliverer" */ "src/components/Dashboard/Views/Fulfiller/deliverer.vue"
  );
const delivererAdd = () =>
  import(
    /* webpackChunkName: "AddDeliverer" */ "src/components/Dashboard/Views/Fulfiller/delivererAdd.vue"
  );
const donators = () =>
  import(
    /* webpackChunkName: "DonatorsList" */ "src/components/Dashboard/Views/Fulfiller/donators.vue"
  );

const usersList = () =>
  import(
    /* webpackChunkName: "ListUsers" */ "src/components/Dashboard/Views/Admin/Users.vue"
  );
const usersAdd = () =>
  import(
    /* webpackChunkName: "AddUsers" */ "src/components/Dashboard/Views/Admin/AddUsers.vue"
  );

const editUsers = () =>
  import(
    /* webpackChunkName: "EditUsers" */ "src/components/Dashboard/Views/Admin/EditUsers.vue"
  );

const dwList = () =>
  import(
    /* webpackChunkName: "DW_List" */ "src/components/Dashboard/Views/Admin/DailyWeight.vue"
  );
const dwAdd = () =>
  import(
    /* webpackChunkName: "DW_Add" */ "src/components/Dashboard/Views/Admin/DailyWeightAdd.vue"
  );
const dwEdit = () =>
  import(
    /* webpackChunkName: "DW_Edit" */ "src/components/Dashboard/Views/Admin/DailyWeightEdit.vue"
  );

const homeEdit = () =>
  import(
    /* webpackChunkName: "tables" */ "src/components/Dashboard/Views/Admin/homeEdit.vue"
  );

const uploadCSV = () =>
  import(
    /* webpackChunkName: "tables" */ "src/components/Dashboard/Views/Admin/uploadCSV.vue"
  );

const historySetting = () =>
  import(
    /* webpackChunkName: "tables" */ "src/components/Dashboard/Views/Admin/historySetting.vue"
  );

const mdList = () =>
  import(
    /* webpackChunkName: "MD_List" */ "src/components/Dashboard/Views/Admin/MarketData.vue"
  );
const mdAdd = () =>
  import(
    /* webpackChunkName: "MD_Add" */ "src/components/Dashboard/Views/Admin/MarketDataAdd.vue"
  );
const mdEdit = () =>
  import(
    /* webpackChunkName: "MD_Edit" */ "src/components/Dashboard/Views/Admin/MarketDataEdit.vue"
  );

const userHome = () =>
  import(
    /* webpackChunkName: "UserHome" */ "src/components/Dashboard/Views/User/UserDashboard.vue"
  );

const adminHome = () =>
  import(
    /* webpackChunkName: "AdminHome" */ "src/components/Dashboard/Views/Admin/AdminDashboard.vue"
  );

let adminLoginPage = {
  path: "/admin-login",
  name: "AdminLogin",
  component: Login
};

let loginUserPage = {
  path: "/login",
  name: "UserLogin",
  component: LoginUser
};

let userHomeMenu = {
  path: "/",
  component: UserDashboardLayout,
  redirect: "/userHome",
  meta: {
    requiresAuth: true
  },
  children: [
    {
      path: "userHome",
      name: "Overview",
      component: userHome
    }
  ]
};

const routes = [
  adminLoginPage,
  loginUserPage,
  userHomeMenu,
  {
    path: "/",
    component: FulfillerDashboardLayout,
    redirect: "/usersList",
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: "adminHome",
        name: "Overview",
        component: adminHome
      },
      {
        path: "usersList",
        name: "Users List",
        component: usersList
      },
      {
        path: "homeEdit",
        name: "Home-Edit",
        component: homeEdit
      },
      {
        path: "historySetting",
        name: "history-setting",
        component: historySetting
      },
      {
        path: "upload",
        name: "upload-csv",
        component: uploadCSV
      },
      {
        path: "editUsers/:usersID",
        name: "Edit-Users",
        component: editUsers
      },
      {
        path: "addUsers",
        name: "Add Users",
        component: usersAdd
      },
      {
        path: "mdList",
        name: "Market-Data-List",
        component: mdList
      },
      {
        path: "mdAdd",
        name: "Market-Data-Add",
        component: mdAdd
      },
      {
        path: "dwList",
        name: "Daily-Weight-List",
        component: dwList
      },
      {
        path: "dwAdd",
        name: "Daily-Weight-Add",
        component: dwAdd
      },
      {
        path: "dwEdit/:dwID",
        name: "Daily-Weight-Edit",
        component: dwEdit
      },
      {
        path: "mdEdit/:mdID",
        name: "Market-Data-Edit",
        component: mdEdit
      },
      {
        path: "changePassword",
        name: "Change-Password",
        component: fulfillerChangePassword
      }
    ]
  },

  {
    path: "*",
    component: () =>
      import(
        /* webpackChunkName: "NotFound" */ "src/components/GeneralViews/NotFoundPage.vue"
      )
  }
];

export default routes;
